import {
    LineBarChart,
    LineChart,
    TargetsAndLines,
} from "@assets/beats/solutions";

export const metaDataHeader = {
    title: "",
    desc: "",
    img: "",
};

export const latest = [
    {
        title: "Every canopy tree of the Amazon forest revealed in new CTrees map",
        date: "06.09.25",
        link: "/news/amazon-canopy-height-map-81",
    },
    {
        title: "CTrees presents on alerts for jurisdictional monitoring at AGU24",
        date: "12.11.24",
        link: "/news/AGU24",
    },
    {
        title: "2023 data on carbon stocks, emissions, and removals for all jurisdictions globally now available",
        date: "11.15.24",
        link: "/jmrv",
    },

];

export const hero = {
    title: "Country & State Programs",
    subheader:
        "Systematic greenhouse gas inventory and environmental monitoring to support jurisdictional policy",
    bgImg: "https://ctrees-website.s3.amazonaws.com/webv3/solutions/hero/country-and-state.png",
};

export const firstBeat = {
    title: "Incomplete information hinders progress",
    subheader:
        "<p>Many countries lack national forest inventory and monitoring systems needed to plan for sustainable resource management and meet Paris Agreement commitments.</p>",
    img: <LineBarChart className={"h-full w-full md:w-3/5"} />,
};
export const secondBeat = {
    title: "Addressing the MRV gap",
    subheader:
        "CTrees’ scientific data is frequent, automatic, and accurate at fine scale, providing near-real-time monitoring and rapid forest inventory for government programs.",
    img: <TargetsAndLines />,
    bg: "https://ctrees-website.s3.amazonaws.com/webv3/solutions/beats/country-and-state.png",
    textRight: true,
};
export const thirdBeat = {
    title: "Informing policy and driving investment",
    subheader:
        "CTrees’ data and insights help governments scale REDD+ programs, meet UNFCCC requirements, and implement effective natural climate solutions.",
    img: <LineChart className={"h-full w-full md:w-3/5"} />,
};

export const dataCards = [
    {
        title: "Remote sensing and the EUDR",
        img: "https://ctrees-website.s3.us-west-2.amazonaws.com/news/25_05+SmallholderFarmerEUDR.jpg",
        imgAlt: "",
        subheader:
            "EUDR implementation presents opportunity to build digital infrastructure for transparent, deforestation-free markets.",
        link: "/news/remote-sensing-eudr-77",
        linkDisplayText: "see more",
    },
    {
        title: "Event recap: Delivering durable finance for tropical forests",
        img: "https://ctrees-website.s3.us-west-2.amazonaws.com/news/LCAW25_Photo2.png",
        imgAlt: "",
        subheader:
            "CTrees event at London Climate Action Week highlights innovations in policy and finance.",
        link: "/news/event-recap-lcaw-2025-84",
        linkDisplayText: "see more",
    },
    {
        title: "Notes from the field: Preparing Arizona’s forests for the future",
        img: "https://ctrees-website.s3.us-west-2.amazonaws.com/news/25_05_SEJ_heroimage.png",
        imgAlt: "",
        subheader:
            "What can the state’s ambitious restoration initiatives teach us about forest and fire management?",
        link: "/news/field-notes-arizona-forest-futures-83",
        linkDisplayText: "see more",
    },
    {
        img: "https://ctrees-website.s3.us-west-2.amazonaws.com/news/25_03+AGEOS2.jpeg",
        imgAlt: "",
        title: "Collaborating with Gabon’s Space agency, AGEOS",
        subheader:
            "Experts from AGEOS visited CTrees for international data exchange.",
        link: "/news/ageos-visit-ctrees-70",
        linkDisplayText: "Read more",
    },
    {
        img: "https://ctrees-website.s3.us-west-2.amazonaws.com/news/24_10+GCF+Peru+Image+1.jpg",
        imgAlt: "",
        title: "Planting the seeds for a new forest economy in Peru",
        subheader:
            "Reflections from the 2024 meeting of the Governors’ Climate & Forests Task Force.",
        link: "/news/gcf-meeting-peru-2024-57",
        linkDisplayText: "see more",
    },
    {
        img: "https://ctrees-website.s3.us-west-2.amazonaws.com/webv3/products/beats/Tree+Level+Slider/Tree-level+slider_left.png",
        imgAlt: "",
        title: "Mapping tree canopy height across California",
        subheader:
            "CTrees scientists applied a deep learning model to map the height of all California’s trees.",
        link: "/news/california-tree-height-map-34",
        linkDisplayText: "learn more",
    },
    {
        img: "https://ctrees-website.s3.us-west-2.amazonaws.com/webv3/solutions/cards/25_04+CT+River+Watershed.jpg",
        imgAlt: "",
        title: "Restoring the Connecticut River Watershed",
        subheader:
            "CTrees is delivering MRV data for a federally funded restoration initiative in Massachusetts",
        link: "https://www.massaudubon.org/news/press-room/2024/mass-audubon-and-partners-receive-25m-federal-grant-to-protect-10-000-acres-in-connecticut-river-watershed",
        linkDisplayText: "read more",
    },
    {
        title: "Quantifying forest degradation in the tropics",
        img: "https://ctrees-website.s3.us-west-2.amazonaws.com/webv3/landing/25_01+Data+Card_REDD%2BAI.png",
        imgAlt: "",
        subheader:
            "CTrees’ open data platform REDD+AI reveals the extent to which human activities have degraded tropical forests since 2017.",
        link: "/news/reddai-data-highlight-55",
        linkDisplayText: "see more",
    },
];

export const dataSubheader =
    "News, insights, and data for country and state programs";
